import React from 'react';
import type { Question } from '../types';

interface PreviewControlsProps {
  question: Question;
  examQuestions: Question[];
  onExamQuestionsChange: (questions: Question[]) => void;
  onHasWidthChangesChange: (hasChanges: boolean) => void;
}

export default function PreviewControls({
  question,
  examQuestions,
  onExamQuestionsChange,
  onHasWidthChangesChange
}: PreviewControlsProps) {
  // 已移除题干图片布局按钮，改为自动布局
  return null;
}
